// src/hooks/useKakaoLogin.ts
import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { evWhereMemberState, isEvWhereMemberState } from '../recoil/atoms';

export const useKakaoLogin = () => {
    const [evWhereMember, setEvWhereMember] = useRecoilState(evWhereMemberState);
    const [isEvWhereMember, setIsEvWhereMember] = useRecoilState(isEvWhereMemberState);

    useEffect(() => {
        const handleMessage = async (event: MessageEvent) => {
            if (event.origin === window.location.origin && event.data.type === 'KAKAO_LOGIN_SUCCESS') {
                const { code } = event.data;
                // console.log('카카오 로그인 코드 받음:', code);

                try {
                    // 1. 인증 코드로 액세스 토큰 받기
                    const tokenResponse = await fetch('https://kauth.kakao.com/oauth/token', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/x-www-form-urlencoded',
                        },
                        body: new URLSearchParams({
                            grant_type: 'authorization_code',
                            client_id: '7bf1c7d17c2e4b703a45ba8a1bb136a2',
                            redirect_uri: `${process.env.REACT_APP_KAKAO_REDIRECT_HOST}/social/kakao`,
                            code: code,
                        }),
                    });

                    const tokenData = await tokenResponse.json();
                    const accessToken = tokenData.access_token;

                    // 2. 사용자 정보 가져오기
                    const userResponse = await fetch('https://kapi.kakao.com/v2/user/me', {
                        headers: {
                            'Authorization': `Bearer ${accessToken}`,
                            'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
                        },
                    });

                    const userData = await userResponse.json();
                    // console.log('카카오 사용자 정보:', userData);

                    // 3. 사용자 정보 설정
                    setEvWhereMember({
                        ssbyp: 'kakao',
                        lgn_Id: userData.kakao_account.email || '',
                        lgnPassword: userData.id.toString(),
                        idToken: userData.id.toString(),
                    });
                    setIsEvWhereMember(true);

                } catch (error) {
                    console.error('카카오 로그인 처리 중 오류:', error);
                }
            }
        };

        window.addEventListener('message', handleMessage);
        return () => window.removeEventListener('message', handleMessage);
    }, []);

    return { evWhereMember, isEvWhereMember };
};